import React from 'react';
import { PastCyclesModel } from '../../../lib/models/PastCyclesModel';
import PastCyclesListItem from './PastCyclesListItem';

export type PastCyclesListProps = {
    data?: PastCyclesModel[];
};

const PastCyclesList = ({ data }: PastCyclesListProps) => {
    return (
        <>
            {data?.map((cycle) => (
                <PastCyclesListItem key={cycle.id} data={cycle} />
            ))}
        </>
    );
};

export default PastCyclesList;
